import { setAppConfig } from "common-frontend-components";
import { getEnvironmentVariable } from "application-common-components";
const isLocal = process.env.REACT_APP_STAGE === 'local';
const apiUrl = isLocal ? "http://localhost:4000/dev" : "https://api.ramibarilan.com";
export const appConfig = setAppConfig({
    apiUrl,
    accountUrl: getEnvironmentVariable('REACT_APP_accountUrl'),
    photosUrl: getEnvironmentVariable('REACT_APP_photosUrl'),
    categoriesUrl: getEnvironmentVariable('REACT_APP_categoriesUrl'),
    postsUrl: getEnvironmentVariable('REACT_APP_postsUrl'),
    postCategoryAssociationsUrl: getEnvironmentVariable('REACT_APP_postCategoryAssociationsUrl'),
    contactsUrl: getEnvironmentVariable('REACT_APP_contactsUrl'),
    sitePhotosUrl: getEnvironmentVariable('REACT_APP_sitePhotosUrl'),
    nftMetadataUrl: getEnvironmentVariable('REACT_APP_nftMetadataUrl'),
    productIconsUrl: getEnvironmentVariable('REACT_APP_productIconsUrl'),
    productPhotosUrl: getEnvironmentVariable('REACT_APP_productPhotosUrl'),
    productsUrl: getEnvironmentVariable('REACT_APP_productsUrl'),
    productPostAssociationsUrl: getEnvironmentVariable('REACT_APP_productPostAssociationsUrl'),
    productCategoryAssociationsUrl: getEnvironmentVariable('REACT_APP_productCategoryAssociationsUrl'),
    galleriesUrl: getEnvironmentVariable('REACT_APP_galleriesUrl'),
    galleryCategoryAssociationsUrl: getEnvironmentVariable('REACT_APP_galleryCategoryAssociationsUrl'),
    galleryIconsUrl: getEnvironmentVariable('REACT_APP_galleryIconsUrl'),
    galleryPhotosUrl: getEnvironmentVariable('REACT_APP_galleryPhotosUrl'),
    reCaptchaSiteKey: '6Lc5is4cAAAAAOMTS4CDx-7y8uTyRf-vcl2gSrpc',
    ipinfo_token: "35b5a926a88486",
    wwwUrl: `${apiUrl}/www`,
    company: 'ramibarilan Inc',
    website: 'ramibarilan.com',
    app_name: 'ramibarilan',
    companyName: "ramibarilan",
    domain: "ramibarilan.com",
    siteUrl: `https://www.ramibarilan.com`,
    app_slogan: 'Get The Best Art Experience',
    app_description: 'Welcome to Rami\'s strip',
    terms_last_update: "April 16 2019",
    desktopMinWidth: 1200,
    // logo,
    googleAnalyticsTrackingId: "UA-215075143-1",
    // address: '40 HaHayalim St, Bitzaron, Israel',
    // phone: '+972 050 xxxx',
    // email: 'ramibarilan@gamil.com',
});
//# sourceMappingURL=appConfig.js.map